import { Avatar, IUser, ListItem, Pill, StringUtils } from '@localina/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    user: IUser;

    restaurantCount: number;
    onClick: (user: IUser) => void;
}

export const UserListItem: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const handleClick = () => {
        props.onClick(props.user);
    };

    const name = StringUtils.combineStrings([props.user.lastName, props.user.firstName], ', ');

    const mappings = (props.user.rolesMapping ?? []).filter((mapping) => mapping.roles.length > 0);
    const roles = mappings
        .flatMap((mapping) => mapping.roles)
        .filter((role, index, all) => all.indexOf(role) === index);

    return (
        <ListItem
            classNames="user-listitem"
            leftIcon={<Avatar name={name} />}
            title={
                <div className="user-listitem__row">
                    <div className="user-listitem__main">
                        <span className="user-listitem__name">{name}</span>
                        <span className="user-listitem__email">{props.user.email}</span>
                    </div>
                    <div className="user-listitem__roles">
                        {roles.map((role) => (
                            <Pill key={role} tone="teal" label={t(`user.roles.${role}`)} />
                        ))}
                    </div>
                    <Pill
                        tone="neutral"
                        label={t('users.venuesOfTotal', {
                            venues: t('users.venuesCount', { count: mappings.length }),
                            total: props.restaurantCount,
                        })}
                    />
                </div>
            }
            onClick={handleClick}
        />
    );
};
